import type { LaundryItem } from '@/types';

/**
 * Demo catalogue for the laundry items & services page (FB03).
 * These are PREVIEW EXAMPLES, not a fixed list — the laundry can add,
 * edit, disable and delete any item. Replaced by the backend catalogue later.
 */
export const mockItems: LaundryItem[] = [
  {
    id: 'ITM-1001',
    name: 'ثوب',
    imageUrl:
      'https://readdy.ai/api/search-image?query=White%20traditional%20Arab%20thobe%20neatly%20folded%20on%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20centered%20composition&width=240&height=240&seq=item-thobe-01&orientation=squarish',
    active: true,
    services: {
      wash_only: { available: true, normal: 12, urgent: 17 },
      iron_only: { available: true, normal: 7, urgent: 10 },
      wash_iron: { available: true, normal: 16, urgent: 22 },
    },
  },
  {
    id: 'ITM-1002',
    name: 'قميص',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Crisp%20white%20men%20dress%20shirt%20folded%20on%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20centered%20composition&width=240&height=240&seq=item-shirt-02&orientation=squarish',
    active: true,
    services: {
      wash_only: { available: true, normal: 8, urgent: 12 },
      iron_only: { available: true, normal: 5, urgent: 8 },
      wash_iron: { available: true, normal: 11, urgent: 16 },
    },
  },
  {
    id: 'ITM-1003',
    name: 'بنطلون',
    imageUrl: null,
    active: true,
    services: {
      wash_only: { available: true, normal: 9, urgent: 13 },
      iron_only: { available: true, normal: 6, urgent: 9 },
      wash_iron: { available: true, normal: 13, urgent: 18 },
    },
  },
  {
    id: 'ITM-1004',
    name: 'عباية',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Black%20elegant%20women%20abaya%20neatly%20displayed%20on%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20centered%20composition&width=240&height=240&seq=item-abaya-04&orientation=squarish',
    active: true,
    services: {
      wash_only: { available: true, normal: 15, urgent: 22 },
      iron_only: { available: false, normal: null, urgent: null },
      wash_iron: { available: true, normal: 25, urgent: 35 },
    },
  },
  {
    id: 'ITM-1005',
    name: 'فستان',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Soft%20beige%20women%20dress%20neatly%20folded%20on%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20centered%20composition&width=240&height=240&seq=item-dress-05&orientation=squarish',
    active: true,
    services: {
      wash_only: { available: true, normal: 14, urgent: 20 },
      iron_only: { available: true, normal: 9, urgent: 13 },
      wash_iron: { available: true, normal: 22, urgent: 30 },
    },
  },
  {
    id: 'ITM-1006',
    name: 'بدلة',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Classic%20navy%20men%20suit%20jacket%20folded%20on%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20clean%20minimal%20e-commerce%20product%20photo%2C%20centered%20composition&width=240&height=240&seq=item-suit-06&orientation=squarish',
    active: true,
    services: {
      wash_only: { available: false, normal: null, urgent: null },
      iron_only: { available: true, normal: 20, urgent: 28 },
      wash_iron: { available: true, normal: 35, urgent: 48 },
    },
  },
  {
    id: 'ITM-1007',
    name: 'جاكيت',
    imageUrl: null,
    active: false,
    services: {
      wash_only: { available: true, normal: 18, urgent: 25 },
      iron_only: { available: true, normal: 12, urgent: 17 },
      wash_iron: { available: true, normal: 28, urgent: 38 },
    },
  },
  {
    id: 'ITM-1008',
    name: 'مفرش',
    imageUrl: null,
    active: true,
    services: {
      wash_only: { available: true, normal: 20, urgent: 28 },
      iron_only: { available: false, normal: null, urgent: null },
      wash_iron: { available: true, normal: 30, urgent: 42 },
    },
  },
];